<template>
  <v-form
    ref="form"
    v-model="valid"
    :lazy-validation="false"
    v-on:submit.prevent="validate"
  >
    <v-toolbar color="rgba(0,0,0,0)" dark flat>
      <v-text-field
        flat
        hide-details
        label="Username or UUID"
        prepend-inner-icon="search"
        :rules="usernameRules"
        solo-inverted
        v-model="username"
        @keyup.enter="validate"
      ></v-text-field>
    </v-toolbar>
  </v-form>
</template>
<script>
export default {
  data: () => ({
    valid: true,
    username: "",
    usernameRules: [v => !!v || "Username is required"]
  }),
  methods: {
    validate(e) {
      e.preventDefault();
      if (this.$refs.form.validate()) {
        this.fixDashlessUUID();
        this.$router.push(`/player/${this.username}`);
      }
    },

    // If the user inputted an UUID without -'s, add them
    fixDashlessUUID() {
      String.prototype.insertAt = function(index, string) {
        return this.substr(0, index) + string + this.substr(index);
      };
      if (this.username.length === 32) {
        this.username = this.username
          .insertAt(8, "-")
          .insertAt(13, "-")
          .insertAt(18, "-")
          .insertAt(23, "-");
      }
      return this.username;
    }
  }
};
</script>
